
L.TileLayer.WMTS = L.TileLayer.extend({
    defaultWmtsParams: {
        service: 'WMTS',
        request: 'GetTile',
        version: '1.0.0',
        layers: '',
        styles: '',
        tilematrixSet: '',
        format: 'image/jpeg'
    },

    initialize: function (url, options) { // (String, Object)
        this._url = url;
        var wmtsParams = L.extend({}, this.defaultWmtsParams);
        var tileSize = options.tileSize || this.options.tileSize;
        if (options.detectRetina && L.Browser.retina) {
            wmtsParams.width = wmtsParams.height = tileSize * 2;
        } else {
            wmtsParams.width = wmtsParams.height = tileSize;
        }
        for (var i in options) {
            // all keys that are not TileLayer options go to WMTS params
            if (!this.options.hasOwnProperty(i) && i!="matrixIds") {
                wmtsParams[i] = options[i];
            }
        }
        this.wmtsParams = wmtsParams;
        this.matrixIds = options.matrixIds||this.getDefaultMatrix();
        L.setOptions(this, options);
    },

    onAdd: function (map) {
        this._crs = this.options.crs || map.options.crs;
        L.TileLayer.prototype.onAdd.call(this, map);
    },

    // provient de Leaflet GridLayer 
    _addTile: function (coords, container) {
       var infoColRow = this.getZoomRowCol(coords);

       var matrixIds = this.matrixIds.filter(function(x){ return x.zoom === infoColRow.zoom});

       if (!matrixIds || matrixIds.length === 0) {
           return;
       }

       var matrixInfo = matrixIds[0];

       if (infoColRow.tileCol > matrixInfo.maxTileCol || infoColRow.tileCol < matrixInfo.minTileCol) {
           return;
       }
       if (infoColRow.tileRow > matrixInfo.maxTileRow || infoColRow.tileRow < matrixInfo.minTileRow) {
           return;
       }

        L.TileLayer.prototype._addTile.call(this, coords, container);

    },
    
    getZoomRowCol: function(coords){
        var tileSize = this.options.tileSize;
        var nwPoint = coords.multiplyBy(tileSize);
        nwPoint.x+=1;
        nwPoint.y-=1;
        var sePoint = nwPoint.add(new L.Point(tileSize, tileSize));
        var zoom = this._tileZoom;
        var nw = this._crs.project(this._map.unproject(nwPoint, zoom));
        var se = this._crs.project(this._map.unproject(sePoint, zoom));
        var tilewidth = se.x-nw.x;
        //zoom = this._map.getZoom();
        var X0 = this.matrixIds[zoom].topLeftCorner.lng;
        var Y0 = this.matrixIds[zoom].topLeftCorner.lat;
        var tileCol=Math.floor((nw.x-X0)/tilewidth);
        var tileRow=-Math.floor((nw.y-Y0)/tilewidth);
        return {zoom: zoom, tileCol: tileCol, tileRow: tileRow};
    },

    getTileUrl: function (coords) { // (Point, Number) -> String
        var infoColRow = this.getZoomRowCol(coords)
        var ident = this.matrixIds[infoColRow.zoom].identifier;
        var url = L.Util.template(this._url, {s: this._getSubdomain(coords)});

        return url + L.Util.getParamString(this.wmtsParams, url) + "&tilematrix=" + ident + "&tilerow=" + infoColRow.tileRow +"&tilecol=" + infoColRow.tileCol ;
    },

    setParams: function (params, noRedraw) {
        L.extend(this.wmtsParams, params);
        if (!noRedraw) {
            this.redraw();
        }
        return this;
    },
    
    getDefaultMatrix : function () {

        var matrixIds3857 = [];
        for (var i= 0; i<22; i++) {
            matrixIds3857[i]= {
                identifier    : "" + i,
                topLeftCorner : new L.LatLng(20037508.3428,-20037508.3428)
            };
        }
        return matrixIds3857;
    }
});

L.tileLayer.wmts = function (url, options) {
    return new L.TileLayer.WMTS(url, options);
};
